import { render, staticRenderFns } from "./BackgroundHolder.vue?vue&type=template&id=2b5dfae2&"
import script from "./BackgroundHolder.vue?vue&type=script&lang=ts&"
export * from "./BackgroundHolder.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundHolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports